"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeProductFromCartCompleted = exports.removeProductFromCartCanceled = exports.removeProductFromCartStart = void 0;
var constants_1 = require("../constants");
var getRemovedProductProps = function (_a) {
    var _b;
    var product = _a.product, session = _a.session;
    return (_b = {},
        _b[constants_1.EventProperty.PRODUCT_ID] = product.id,
        _b[constants_1.EventProperty.PRODUCT_CATEGORY] = product.category,
        _b[constants_1.EventProperty.PRODUCT_NAME] = product.name,
        _b[constants_1.EventProperty.PRODUCT_PRICE] = product.price,
        _b[constants_1.EventProperty.PRODUCT_SKU] = product.sku,
        _b[constants_1.EventProperty.PRODUCT_TOTAL_PRICE] = product.totalPrice,
        _b[constants_1.EventProperty.USER_ID] = session.userID,
        _b[constants_1.EventProperty.CUSTOMER_NAME] = session.customer,
        _b);
};
exports.removeProductFromCartStart = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getRemovedProductProps({
        product: product,
        session: session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_START, props);
};
exports.removeProductFromCartCanceled = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getRemovedProductProps({
        product: product,
        session: session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_CANCELED, props);
};
exports.removeProductFromCartCompleted = function (_a) {
    var product = _a.product, session = _a.session;
    var props = getRemovedProductProps({
        product: product,
        session: session,
    });
    window.analytics.track(constants_1.EventName.PRODUCT_ELIMINATED_FROM_CART_COMPLETED, props);
};
